import * as types from "./actionTypes";
import * as eventTypes from "./eventTypes";
import initialState from "reducers/initialState";

export default function consentReducer(state = initialState.currentOffer.clientConsentData, action) {
  switch (action.type) {
    case types.LOAD_PARTNER_CONSENTS_SUCCEEDED: {
      const { partnerConsents } = action.payload;
      const partnerId = partnerConsents.partnerId;
      const consents = {
        ...state.consents,
        [partnerId]: {
          partnerId,
          isLoaded: true
        }
      };

      return {
        ...state,
        consents
      };
    }

    case eventTypes.OFFER_PARTNER_CONSENTS_INVALIDATED: {
      const { partnerId } = action.event.eventBody;
      const consents = {
        ...state.consents,
        [partnerId]: {
          partnerId,
          isLoaded: false
        }
      };
      return { ...state, consents };
    }

    case eventTypes.OFFER_CLIENT_CONSENT_UPDATED: {
      let index = state.clientConsent.findIndex(a => a.consentTypeId === action.event.eventBody.consentTypeId);

      if (index !== -1) {
        const clientConsent = Object.assign([...state.clientConsent], {
          [index]: { ...state.clientConsent[index], ...action.event.eventBody }
        });
        return {
          ...state,
          clientConsent,
          isLoaded: true
        };
      } else {
        return {
          ...state
        };
      }
    }

    default:
      return state;
  }
}
